import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PopupPortal from "./PopupPortal";

export const Toaster = ({
  textBody,
  timeHide = 4000,
  color = "primaryColor",
  close,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const typesColors = {
    primaryColor: "border-b-green-500",
    warningColor: "border-b-yellow-500",
    dangerColor: "border-b-red-500",
    loadingColor: "border-b-blue-500",
  };

  setTimeout(() => {
    setIsVisible(false);
  }, timeHide);

  useEffect(() => {
    if (!isVisible) close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <PopupPortal>
      <div className="fixed flex items-center w-full max-w-xs p-4 space-x-4 divide-x divide-gray-200 top-5 right-28 space-x z-[100]">
        <AnimatePresence>
          {isVisible === true ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.25 }}
            >
              <div
                className={`w-80 px-4 py-6 flex justify-between rounded-lg border-b-8 ${typesColors[color]} bg-white shadow-2xl`}
              >
                <div className="text-md font-normal mt-4">{textBody}</div>
                <div className="flex items-center ml-1 space-x-1">
                  <button
                    type="button"
                    className="bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8"
                    data-dismiss-target="#toast-undo"
                    aria-label="Close"
                    onClick={() => {
                      setIsVisible(false);
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </motion.div>
          ) : (
            ""
          )}
        </AnimatePresence>
      </div>
    </PopupPortal>
  );
};

export default Toaster;
